export const LCA_RATING_COLORS: Record<string, string> = {
  C1: "#008155",
  C2: "#54a64a",
  C3: "#99b433",
  C4: "#feca2e",
  C5: "#fe9924",
  C6: "#d76900",
  C7: "#be3c38",
}
